import * as tslib_1 from "tslib";
import { OnDestroy, OnInit } from '@angular/core';
import { FormControl } from '@angular/forms';
import { fromEvent, merge, Subject } from 'rxjs';
import { debounceTime, switchMap, takeUntil } from 'rxjs/operators';
import { sentry } from '../../../../../../../sentry';
import { CustomMessagesService } from '../../../../../../core/errors/custom-messages.service';
import { delay } from '../../../../../../core/utils/delay';
import { EquipmentLinkService } from './services/equipment/equipment.service';
import { LocationLinkEnvironmentService } from './services/location-environment/location-environment.service';
import { LocationLinkSectorService } from './services/location-sector/location-sector.service';
import { LocationTabLinksService } from './tab-links.service';
var TabLinksComponent = /** @class */ (function () {
    function TabLinksComponent(messageService, locationLinksTabModalService, locationSectorService, locationEnvironmentService, equipmentService) {
        this.messageService = messageService;
        this.locationLinksTabModalService = locationLinksTabModalService;
        this.locationSectorService = locationSectorService;
        this.locationEnvironmentService = locationEnvironmentService;
        this.equipmentService = equipmentService;
        this.searchTerm = new FormControl('');
        this.destroy$ = new Subject();
        this.isEmpty = true;
        this.isLoading = false;
        this.locationLinks = [];
        this.unlinkedEquipments = [];
    }
    TabLinksComponent.prototype.openCreateSectorDialog = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.locationSectorService.openCreateLocationSectorDialog({ location: this.location })];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    TabLinksComponent.prototype.openCreateEquipmentDialog = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.equipmentService.openCreateEquipmentDialog({ location: this.location })];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    TabLinksComponent.prototype.openCreateEnvironmentDialog = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.locationEnvironmentService.openCreateLocationEnvironmentDialog({
                            location: this.location,
                            locationSectorId: null
                        })];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    TabLinksComponent.prototype.ngOnInit = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var _this = this;
            return tslib_1.__generator(this, function (_a) {
                merge(this.searchTerm.valueChanges.pipe(debounceTime(1000)), fromEvent(window, 'location-links::reload-tree-view')).pipe(takeUntil(this.destroy$), switchMap(function () { return _this.loadLocationLinks(); })).subscribe();
                window.emitEvent('location-links::reload-tree-view');
                return [2 /*return*/];
            });
        });
    };
    TabLinksComponent.prototype.ngOnDestroy = function () {
        this.destroy$.next();
        this.destroy$.complete();
    };
    TabLinksComponent.prototype.loadLocationLinks = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var _a, locationSectors, locationEnvironments, equipments;
            var _this = this;
            return tslib_1.__generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        this.isLoading = true;
                        return [4 /*yield*/, Promise.all([
                                this.searchLocationSectors(),
                                this.searchLocationEnvironments(),
                                this.searchEquipments(),
                                delay(500)
                            ]).catch(function (error) {
                                _this.messageService.error('UNKNOWN_ERROR');
                                sentry.captureException(error);
                                return [[], [], []];
                            })];
                    case 1:
                        _a = tslib_1.__read.apply(void 0, [_b.sent(), 3]), locationSectors = _a[0], locationEnvironments = _a[1], equipments = _a[2];
                        return [4 /*yield*/, this.populateLocationLinks({
                                sectors: locationSectors,
                                environments: locationEnvironments,
                                equipments: equipments
                            })];
                    case 2:
                        _b.sent();
                        this.isLoading = false;
                        return [2 /*return*/];
                }
            });
        });
    };
    TabLinksComponent.prototype.searchLocationSectors = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            return tslib_1.__generator(this, function (_a) {
                return [2 /*return*/, this.locationLinksTabModalService.searchLocationSectors({
                        locationId: this.location.id,
                    })];
            });
        });
    };
    TabLinksComponent.prototype.searchLocationEnvironments = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            return tslib_1.__generator(this, function (_a) {
                return [2 /*return*/, this.locationLinksTabModalService.searchLocationEnvironments({
                        locationId: this.location.id,
                    })];
            });
        });
    };
    TabLinksComponent.prototype.searchEquipments = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            return tslib_1.__generator(this, function (_a) {
                return [2 /*return*/, this.locationLinksTabModalService.searchEquipments({
                        locationId_in: [this.location.id],
                        name_or_number_or_sector_or_environment_contains: this.searchTerm.value.trim().toLowerCase(),
                    })];
            });
        });
    };
    TabLinksComponent.prototype.populateLocationLinks = function (params) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var _a, sectors, equipments, _b, _c;
            var _this = this;
            return tslib_1.__generator(this, function (_d) {
                switch (_d.label) {
                    case 0:
                        _a = this.locationLinksTabModalService.linkSectorsEnvironmentsEquipments({
                            sectors: params.sectors,
                            environments: params.environments,
                            equipments: params.equipments
                        }), sectors = _a.sectors, equipments = _a.equipments;
                        _b = this;
                        return [4 /*yield*/, this.locationLinksTabModalService.formatSectors(sectors)
                                .then(function (items) { return _this.filter(items, _this.searchTerm.value.trim().toLowerCase()); })];
                    case 1:
                        _b.locationLinks = _d.sent();
                        _c = this;
                        return [4 /*yield*/, this.locationLinksTabModalService.formatUnlinkedEquipments(equipments)
                                .then(function (items) { return _this.filter(items, _this.searchTerm.value.trim().toLowerCase()); })];
                    case 2:
                        _c.unlinkedEquipments = _d.sent();
                        this.isEmpty = !this.locationLinks.length && !this.unlinkedEquipments.length;
                        return [2 /*return*/];
                }
            });
        });
    };
    TabLinksComponent.prototype.filter = function (items, searchTerm) {
        var _this = this;
        return items.filter(function (item) {
            if (!searchTerm) {
                return true;
            }
            if (item.children) {
                item.children = _this.filter(item.children, searchTerm);
            }
            return item.searchTerm.includes(searchTerm) || (item.children && item.children.length) || _this.parentMatch(item, searchTerm);
        });
    };
    TabLinksComponent.prototype.parentMatch = function (item, searchTerm) {
        if (!item.parent) {
            return false;
        }
        return item.parent.searchTerm.includes(searchTerm) || this.parentMatch(item.parent, searchTerm);
    };
    return TabLinksComponent;
}());
export { TabLinksComponent };
